// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1Dcvq","header":"MessagesList_header__3ggGZ","chat":"MessagesList_chat__357El"};